import React, { useRef, useEffect, useState } from "react";
import Title from "../layouts/Title";
import FeatureCard from "./FeatureCard";

const Features = () => {
  const [visibleCards, setVisibleCards] = useState([]);
  const cardsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = parseInt(entry.target.dataset.index);
            setVisibleCards((prev) => [...prev, index]);
          }
        });
      },
      {
        threshold: 0.1,
      }
    );

    const currentCards = cardsRef.current;
    currentCards.forEach((card) => {
      if (card) observer.observe(card);
    });

    return () => {
      currentCards.forEach((card) => {
        if (card) observer.unobserve(card);
      });
    };
  }, []);

  const featureData = [
    {
      title: "AI-Driven Solutions",
      description:
        "Developing AI for e-Commerce & SaaS platforms using GPT and RAG principles to enhance user engagement and product efficiency.",
    },
    {
      title: "SaaS Product Management",
      description:
        "Leading product lifecycles for SaaS with data-driven insights and A/B testing. Optimizing Agile workflows to accelerate delivery.",
    },
    {
      title: "E-commerce Development",
      description:
        "Specializing in Dokan multivendor, WooCommerce, and WordPress plugins with API integration for seamless user experiences.",
    },
    {
      title: "UI/UX Design & Frontend",
      description:
        "Creating responsive web applications with React. Skilled in Figma for prototyping and comprehensive UI design systems.",
    },
  ];

  return (
    <section id="expertise" className="w-full py-20 section-divider">
      <div className="max-w-screen-xl mx-auto px-4">
        <Title title="Areas of Expertise" />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {featureData.map((feature, index) => (
            <div
              key={index}
              ref={(el) => (cardsRef.current[index] = el)}
              data-index={index}
              className="opacity-0 transform translate-y-[30px] transition-all duration-700"
              style={{
                opacity: visibleCards.includes(index) ? 1 : 0,
                transform: visibleCards.includes(index)
                  ? "translateY(0)"
                  : "translateY(30px)",
                transitionDelay: `${index * 150}ms`,
              }}
            >
              <FeatureCard
                title={feature.title}
                description={feature.description}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
